import Vue from 'vue'
import router from '@/router'
import store from '@/store/'

import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import {
  setDocumentTitle,
  setDocumentKeywords,
  setDocumentDescription,
  domTitle
} from '@/utils/domUtil'
import { ACCESS_TOKEN, ACCOUNT_TYPE, REGION } from '@/store/mutation-types'
import {
  whiteList,
  defaultRoutePath,
  loginCannotAccess
} from '@/config/router.config.js'

NProgress.configure({ showSpinner: false }) // 页面加载顶部上面的进度条
// 路由前置守位
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta &&
    typeof to.meta.title !== 'undefined' &&
    setDocumentTitle(`${to.meta.title} - ${domTitle}`) //   设置页面标题
  to.meta &&
    typeof to.meta.keywords !== 'undefined' &&
    setDocumentKeywords(`${to.meta.keywords}`) //   设置页面标题
  to.meta &&
    typeof to.meta.description !== 'undefined' &&
    setDocumentDescription(`${to.meta.description}`) //   设置页面标题
  // 设置当前位置
  store.dispatch('SetRegion', Vue.ls.get(REGION))
  const accountType = Vue.ls.get(ACCOUNT_TYPE, 'user')
  /* 检查JWT token */
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* 登录状态不可访问的路径，跳转默认路由 */
    if (loginCannotAccess.includes(to.name)) {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      // 使用f5刷新，页面状态管理清空。重新请求用户类型
      if (store.getters.addRouters.length === 0) {
        const storeMethod =
          accountType === 'user' ? 'UserGetInfo' : 'TeacherGetInfo'
        store
          .dispatch(storeMethod)
          .then((res) => {
            // 根据类型处理需要被控制的访问路由
            store.dispatch('GenerateRoutes', { accountType }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表。刚开始的路由表只有基础路由。现在加入筛选后的路由
              router.addRoutes(store.getters.addRouters)
              // 请求带有 redirect 重定向时，登录自动重定向到该地址
              const redirect = decodeURIComponent(
                from.query.redirect || to.path
              )
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成，set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          })
          .catch(() => {
            Vue.ls.remove(ACCESS_TOKEN)
            Vue.ls.remove(ACCOUNT_TYPE)
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试'
            })
            next()
            // store.dispath('Logout').then(() => {
            //   next({ name: 'userLogin', query: { redirect: to.fullPath } })
            // })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // 判断是用户还是教员
      Vue.ls.get(ACCESS_TOKEN)
      if (accountType === 'teacher') {
        next({ name: 'TeacherLogin', query: { redirect: to.fullPath } })
      } else {
        next({ name: 'UserLogin', query: { redirect: to.fullPath } })
      }
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
